import React from "react";
import { Col, Row, ListGroup } from "react-bootstrap";
import { StyledHeadText, StyledEventText } from "./StyledComponents";
import { StyledButton } from "../../../components/Elements/StyledComponents";
import { SelectedCandidates } from "./SelectedCandidates";

export const SelectedEvents = ({ list, onDelete, onDeleteCandidate }) => (
  <Row className="justify-content-center mt-3">
    <Col xs={"auto"}>
      <span>Selected events</span>
    </Col>
    <Col xs={"auto"}>
      <ListGroup>
        {list.map((currentEvent) => (
          <ListGroup.Item
            key={currentEvent.eventTime}
            as="li"
            variant="success"
            className="w-90 d-flex align-items-center"
          >
            <StyledHeadText>{currentEvent.answer}</StyledHeadText>
            <SelectedCandidates
              list={currentEvent.candidates_active}
              text="active:"
              eventTime={currentEvent.event_time}
              type="candidates_active"
              onDelete={onDeleteCandidate}
            />
            <SelectedCandidates
              list={currentEvent.candidates_passive}
              text="passive:"
              eventTime={currentEvent.event_time}
              type="candidates_passive"
              onDelete={onDeleteCandidate}
            />
            <StyledEventText>
              <span>start time:</span>{" "}
              {currentEvent.start_event_time.toFixed(2).replace(/[.,]00$/, "")}
            </StyledEventText>
            <StyledEventText>
              <span>end time:</span>{" "}
              {currentEvent.end_event_time.toFixed(2).replace(/[.,]00$/, "")}
            </StyledEventText>
            <StyledButton
              key={currentEvent.answer}
              variant="danger"
              onClick={() => onDelete(currentEvent.answer)}
            >
              delete
            </StyledButton>
          </ListGroup.Item>
        ))}
      </ListGroup>
    </Col>
  </Row>
);
